import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
    element.style.position = "fixed";
    element.style.top = (window.innerHeight * 0.225) + "px";  
    element.style.left = (window.innerWidth * 0.408) + "px";
    element.style.width = (window.innerWidth * 0.076) + "px";
}

const battleRoom: DirectiveOptions = {
    inserted(el, binding) {
        setPosition(el, binding);
    },
    update(el, binding) {
        setPosition(el, binding);
    }
};

export default battleRoom;
